import React from 'react';
import PropTypes from 'prop-types';
import Iconify from '../common/iconify.component';

const Sortable = ({ dataKey, sortBy, sortOrder }) => {
  if (dataKey === sortBy && sortOrder === 'asc') {
    return (
      <Iconify
        icon="mdi:arrow-up"
        width={14}
        height={14}
        sx={{ marginLeft: 0.5, color: '#637381', fontSize: '14px' }}
      />
    );
  }
  if (dataKey === sortBy && sortOrder === 'desc') {
    return (
      <Iconify
        icon="mdi:arrow-down"
        width={14}
        height={14}
        sx={{ marginLeft: 0.5, color: '#637381', fontSize: '14px' }}
      />
    );
  }

  return (
    <Iconify
      icon="solar:sort-vertical-bold-duotone"
      width={14}
      height={14}
      sx={{ marginLeft: 0.5, color: '#C4CDD5', fontSize: '14px' }}
    />
  );
};

Sortable.propTypes = {
  dataKey: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
};

export default Sortable;
